import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useLayout } from "@/lib/layout";
import { Header } from "@/components/site/Header";
import { Ticker } from "@/components/site/Ticker";
import { Footer } from "@/components/site/Footer";
import { SiteHead } from "@/components/site/Seo";
import { CookieBanner } from "@/components/site/CookieBanner";
import { Tracking } from "@/components/site/Tracking";

export { useLayout };

export default function SiteLayout() {
  const { pathname } = useLocation();
  const { data } = useLayout();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const ticker = data?.settings?.ticker_enabled && data.ticker?.length > 0;
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <SiteHead />
      <Tracking />
      <Header categories={data?.categories || []} settings={data?.settings} />
      {ticker && <Ticker items={data.ticker} />}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer categories={data?.categories} settings={data?.settings} />
      <CookieBanner />
    </div>
  );
}
